import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LanguageService } from './utils/language/language.service';
import { ActivityLogService } from './utils/activity-log/activity-log.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FuseLoadingBarModule } from 'fuseui';
import { HlmToaster } from '@spartan-ng/helm/sonner';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FuseLoadingBarModule, RouterOutlet, HlmToaster],
})
@UntilDestroy()
export class AppComponent implements OnInit{

    private userHash?:string;
    constructor(
        private translate: TranslateService,
        private titleService: Title,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private languageService: LanguageService,
        private _activityLogService: ActivityLogService,
    ) {
        this.activatedRoute.queryParams.pipe(
            untilDestroyed(this)
        ).subscribe(params => {
            this.userHash = params['token'];
        });
        this.translate.addLangs(this.languageService.supportedLanguages);
    }

    ngOnInit() {
        this.languageService.initAppLanguage();

        if (this._activityLogService.isPageRefresh()) {
            this._activityLogService.logActivity('page-refresh', { screenName: 'Obnovení stránky' });
        }

        // Immediately restore title from last visit to avoid "Sting" flash during bootstrap
        const savedTitle = localStorage.getItem('lastPageTitle');
        const savedUrl = localStorage.getItem('lastPageTitleUrl');
        if (savedTitle && savedUrl === window.location.pathname) {
            this.titleService.setTitle(savedTitle);
        }

        this.router.events.pipe(
            untilDestroyed(this),
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            const title = this.findRouteTitle(this.activatedRoute.snapshot);
            if (title) {
                const companyName = localStorage.getItem('activeCompanyName') || 'PORTÁL';
                const dynamicTitle = title.replace('STING', companyName);
                this.titleService.setTitle(dynamicTitle);
                localStorage.setItem('lastPageTitle', dynamicTitle);
                localStorage.setItem('lastPageTitleUrl', window.location.pathname);
            }
        });
    }

    // Depth-first search: prefers deepest child with a title, falls back to parent
    private findRouteTitle(snapshot: ActivatedRouteSnapshot): string | null {
        for (const child of snapshot.children) {
            const childTitle = this.findRouteTitle(child);
            if (childTitle) return childTitle;
        }
        return snapshot.data?.title ?? null;
    }


}
